"use client";

import React from "react";
import { LocaleLink as Link } from "@/components/shared/LocaleLink";
import { useTranslations } from "@/lib/i18n-client";
import { Reveal } from "@/components/shared/motion";
import { ArrowRight, Mail, ShieldCheck } from "lucide-react";

/**
 * Travel Connected — homepage closing CTA band. Solid bright-blue commercial
 * band (NO gradient) with the core promise + a single primary action.
 */
export default function FinalCta() {
  const { t } = useTranslations();

  return (
    <section className="container mx-auto px-4 pb-14">
      <Reveal as="div" className="rounded-2xl bg-primary text-primary-foreground p-8 sm:p-12 text-center shadow-md" y={22}>
        <h2 className="text-2xl sm:text-3xl font-extrabold">{t("pc.finalCta.title", "Ready to travel connected?")}</h2>
        <p className="mt-2 opacity-90 max-w-xl mx-auto">{t("pc.finalCta.sub", "Pick your destination, pay securely, and get your eSIM by email in minutes.")}</p>
        <Link href="/destinations/" className="mt-6 inline-flex items-center gap-2 rounded-full bg-card text-foreground font-bold px-7 h-12 hover:bg-card/90 transition-all active:scale-[0.98] group/fc">
          {t("pc.finalCta.cta", "Shop eSIMs")} <ArrowRight className="w-4 h-4 transition-transform group-hover/fc:translate-x-0.5" />
        </Link>
        <div className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm opacity-90">
          <span className="inline-flex items-center gap-1.5"><Mail className="w-4 h-4" />{t("pc.finalCta.b1", "Instant email delivery")}</span>
          <span className="inline-flex items-center gap-1.5"><ShieldCheck className="w-4 h-4" />{t("pc.finalCta.b2", "Secure checkout")}</span>
        </div>
      </Reveal>
    </section>
  );
}
